<button (click)="openAdvancedClaimedTaskTab()" class="selectReviewerAction btn btn-primary"
        ngbTooltip="{{ 'submission.workflow.generic.' + option + '-help' | translate }}">
  <i class="fa fa-user"></i> {{ 'submission.workflow.generic.' + option | translate}}
</button>
